import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cbdf5a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-image" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask-layer" }, null, -1))
const _hoisted_3 = { class: "active-tag" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "outer-sphere" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "goods-price" }
const _hoisted_8 = { class: "standard" }
const _hoisted_9 = { class: "proportion" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Grab lt")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sold Out")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Coming Up")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: "page-goods-list",
    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.unifiedJump($props.item)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, " - " + _toDisplayString($setup.get_price_type_fn()) + " %", 1),
      _withDirectives(_createElementVNode("img", {
        alt: $props.item.goods.goods_name
      }, null, 8, _hoisted_4), [
        [_directive_lazy, _ctx.webpFilters($props.item.goods.images.L)]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", {
        class: "goods-name",
        innerHTML: $props.item.goods.goods_name
      }, null, 8, _hoisted_6),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, [
          _createElementVNode("b", null, _toDisplayString($setup.currencyUnit), 1),
          _createTextVNode(" " + _toDisplayString(parseInt($props.item.price).thousands()), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString($setup.currencyUnit), 1),
          _createTextVNode(" " + _toDisplayString(' '+ parseInt($props.item.goods.goods_marketprice ).thousands()), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createElementVNode("p", {
              style: _normalizeStyle({ width: parseInt((parseInt($props.item.remaining) / parseInt($props.item.storage) *100 ))  +  '%' })
            }, null, 4)
          ])
        ]),
        ($props.status_name === 'On Going' && $props.item.remaining > 0)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 0,
              color: "#ff582a",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ($props.status_name === 'On Going' && $props.item.remaining <= 0)
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 1,
              color: "#ffd5b9",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ($props.status_name !== 'On Going')
          ? (_openBlock(), _createBlock(_component_van_button, {
              key: 2,
              color: "#dfdfdf",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}